<template>
    <div>
        <div class="container mx-auto page no-top-bar" v-if="campaign != null && isSurvey == false"
            :class="{'pb-0': campaign.type == campaignType.Event}">
            <TopBarDetail
                v-if="campaign.type != campaignType.Event"
                ref="topbar-detail"
                :isShowBack="true"
                :isShowFavorite="true"
                :isShowShare="true"
                @clickShare="clickShare()"
                @clickFav="clickFav()"
                @clickBack="clickBack()"
            ></TopBarDetail>
            <div v-if="campaign != null">
                <div v-if="campaign.type == campaignType.Media">
                    <TypeMedia :campaign="campaign"></TypeMedia>
                </div>
                <div v-else-if="campaign.type == campaignType.Event">
                    <TypeEvents :campaign="campaign" @clickBack="clickBack()"></TypeEvents>
                </div>
                <div v-else-if="campaign.type == campaignType.News">
                    <TypeNews :campaign="campaign" @clickBack="clickBack()"></TypeNews>
                </div>
                <div class="" v-else>
                    <div class="px-4">
                        <Picture :campaign="campaign"></Picture>
                    </div>
                    <div class="px-4 pb-4">
                        <div class="bg-white px-6 py-4 rounded-xl">
                            <DetailInfo :campaign="campaign"></DetailInfo>
                            <RedeemButton
                                    class="mt-5"
                                    :detailController="detailController"
                                    :modalController="modalController"
                                    @clickRedeem="clickRedeem()"
                            ></RedeemButton>
                        </div>
                    </div>
                    <div class="px-4">
                        <div class="bg-white px-6 py-4 rounded-xl">
                            <Condition :campaign="campaign"></Condition>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
import { CampaignType } from "@/helper/StaticValue.js";
//component
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';
import DetailInfo from '../component/DetailInfo.vue';
import Picture from '../component/Picture.vue';
import Condition from '../component/Condition.vue';
import RedeemButton from '../component/RedeemButton.vue';
import TypeMedia from '../Layout/TypeMedia.vue';
import TypeEvents from '../Layout/TypeEvents.vue';
import TypeNews from '../Layout/TypeNews.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin'
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import { StaticLevel,UserLevel } from "@/core/UserLevel/UserLevelDetail.js";

export default {
    name: "Campaign",
    mixins: [ModalMixin,LocaleMixin, AuthStatusMixin],
    components: {
        TopBarDetail,
        DetailInfo,
        Picture,
        Condition,
        RedeemButton,
        TypeMedia,
        TypeEvents,
        TypeNews,
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            campaign: null,
            campaignType: CampaignType,
            isSurvey: true,
        };
    },
    created: function() {
        this.tracking.screenName('campaign_detail');
        this.initialIsFromLanding();
    },
    methods: {
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        onAccountInit: function() {
            this.initialCampaign();
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function () {
            let campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            let backCount = this.$route.query.back;
            if (Util.isNumber(backCount) && backCount != 0) {
                this.$router.go(backCount);
            }
        },
        //#endregion initial

        //#region setup
        setupDetailController: function() {
            this.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                Util.log("campaign", campaign);
                this.campaign = campaign;
                this.bzbsTracking('view_campaign_detail');
                if (this.isCampaignTypeSurvey()) {
                    this.isSurvey = true;
                    window.location.replace("/campaignSurvey/" + this.campaign.id);
                } else {
                    this.isSurvey = false;
                }
                this.redeemController.initial(this.campaign, this.modalController, this.tracking);
                this.setRedeemEvent();
                this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.loadingModal.hide();
            });
        },
        //#endregion setup

        //#region event
        clickRedeem: function() {
            let level = this.getLevelText();
            if (!level) {
                this.modalController.confirmModal
                                    .clearModal()
                                    .setTag('verifiedlaserno')
                                    .setMsg(this.lbl.verify_laser_id.before_redeem)
                                    .setBtnOk(this.lbl.verify_laser_id.confirm_btn)
                                    .show()
                this.modalController.confirmModal.onClickOk(() => {
                    let url = `${ConfigManager.getWebSofinUrl()}/editinfo?return_url=${this.$route.path.substring(1,this.$route.path.length)}`
                    window.location.replace(url);
                });
            } else {
                this.bzbsTracking('click_redeem')
                let selectCampaignId = this.detailController.selectedCampaignId;
                let selectedQuantity = this.detailController.selectedQuantity;
                this.redeemController.clickRedeem(selectCampaignId, selectedQuantity);
            }
        },
        setRedeemEvent: function() {
            this.redeemController.onClickRedeem = () => {
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onRedeemError = (err) => {
                this.errorApi(err);
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = () => {
                this.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.loadingModal.hide();
                return true;
            };
        },
        clickShare: function() {
            this.bzbsTrackingHeader('click_share')
            this.modalController.shareModal.clearModal()
                                        .setCampaign(this.campaign)
                                        .show();
            this.modalController.shareModal.onClickShare((shareType)=> {
                let share_url = window.location.href;
                if (shareType == "facebook") {
                    let urlFacebook = "https://www.facebook.com/dialog/feed?app_id=" + ConfigManager.getAppId() + "&display=page&link=" + encodeURIComponent(share_url) + "&redirect_uri=" + encodeURIComponent(share_url) + "&source=" + encodeURIComponent(this.campaign.fullImageUrl);
                    window.open(urlFacebook, '_blank');
                } else if (shareType == "line") {
                    let urlLine = "https://lineit.line.me/share/ui?url=" + encodeURIComponent(share_url) + "&text=" + encodeURIComponent("");
                    window.open(urlLine, '_blank');
                } else if (shareType == "twitter") {
                    let urlTwitter = "http://twitter.com/share?url=" + encodeURIComponent(share_url);
                    window.open(urlTwitter, '_blank');
                }
            });
        },
        clickFav: function() {
            this.bzbsTrackingHeader('click_favorite')
            this.checkLoginPopup(()=> {
                this.loadingModal.show();
                this.detailController.clickFavourite().then((campaign) => {
                    Util.log("campaign", campaign);
                    this.$refs['topbar-detail'].updateFavorite(campaign.isFavourite);
                }).catch((err) => {
                    this.errorApi(err);
                }).finally(() => {
                    this.loadingModal.hide();
                });
            })

        },
        //#endregion event
        clickBack: function() {
            this.bzbsTrackingHeader('click_back')
            if (this.$route.query.back == 'airasia') {
                this.$router.push('/home')
            } else {
                this.$router.back();
            }
        },
        onLoadedCampaign: function() {
            setTimeout(()=> {
                this.$refs['topbar-detail'].updateFavorite(this.campaign.isFavourite);
            },300);
        },
        isCampaignTypeSurvey: function() {
            return (this.campaign.type == CampaignType.Interface)
                && (this.campaign.website.indexOf('survey') >= 0);
        },
        getLevelText: function () {
            if (this.isLogin) {
                this.level = {...StaticLevel};
                this.userLevel = new UserLevel();
                return this.userLevel.getLevelVerifiedlaserno();
            } else {
                return "";
            }

        },
        bzbsTracking: function(eventTacking) {
            if(this.campaign.type == 16) {
                this.tracking.event('news', eventTacking, this.campaign.id);           
            } else {
                this.tracking.event('privilege_detail', eventTacking, this.campaign.id + '|' + this.campaign.name);
            }
        },
        bzbsTrackingHeader: function(eventTacking) {
            if(this.campaign.type  == 16) {
                this.tracking.event('news_header', eventTacking, this.campaign.id);
            } else {
                this.tracking.event('privilege_detail_header', eventTacking, this.campaign.id + '|' + this.campaign.name);
            }
        }
    },
}
</script>
